import { apiClient } from '@/services/ApiClient.js'

export default {
  getPayments(id, query) {
    return apiClient
      .get('retailers/' + id + '/retailer-payments', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getOrderPayments(retailerId, paymentId, withTrashed = false) {
    return apiClient
      .get('retailers/' + retailerId + '/retailer-payments/' + paymentId, {
        params: {
          with_trashed: withTrashed
        }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getRetailerOrderPayments(retailerId, paymentId, withTrashed = false) {
    return apiClient
      .get(`retailers/${retailerId}/retailer-payments/${paymentId}/order-payments`, {
        params: {
          with_trashed: withTrashed
        }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deletePayment(retailerId, id) {
    return apiClient
      .delete('retailers/' + retailerId + '/retailer-payments/' + id)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getPayable(id) {
    return apiClient
      .get('retailers/' + id + '/payments' + '/payable')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getNettable(id) {
    return apiClient
      .get('retailers/' + id + '/payments' + '/nettable')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createPayOrders(retailerId, orders, paidDate, notify) {
    return apiClient
      .post('retailers/' + retailerId + '/pay-orders', {
        orders: orders,
        paid_date: paidDate,
        notify: notify
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  createPayAmount(retailerId, amount, paidDate, notify) {
    return apiClient
      .post('retailers/' + retailerId + '/pay-amount', {
        amount: amount,
        paid_date: paidDate,
        notify: notify
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  netting(retailerId, nettingBody) {
    return apiClient
      .post('retailers/' + retailerId + '/netting', nettingBody)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
